import { render } from "./TransactionsHistory.vue?vue&type=template&id=5d21d7c8&ts=true"
import script from "./TransactionsHistory.vue?vue&type=script&lang=ts"
export * from "./TransactionsHistory.vue?vue&type=script&lang=ts"

import "./TransactionsHistory.vue?vue&type=style&index=0&id=5d21d7c8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__